import { BaSeButton, BaSeDialogContext, BaSeTheme } from '@base/react';
import { format } from 'date-fns';
import React, { useState } from 'react';
import { useInterviewController } from '../../../../../../../hooks/controllers/interview-controller';
import { useModule } from '../../../../../../../hooks/module/module';
import ConfirmGenerateCertificate from './confirm-generate-certificate';
import GenerateCertificateData from './generate-certificate-data';
import { Container, FooterContainer } from './generate-certificate-style';

// eslint-disable-next-line sonarjs/cognitive-complexity
function GenerateCertificate({ values, closeModal, reloadData }) {
  const { moduleSelected } = useModule();
  const [confirmGenerate, setConfirmGenerate] = useState(false);

  const [initialDate, setInitialDate] = useState();
  const [finalDate, setFinalDate] = useState();
  const [cargaHoraria, setCargaHoraria] = React.useState(60);
  const [loadingButton, setLoadingButton] = React.useState(false);

  const { showNotification } = React.useContext(BaSeDialogContext);
  const { gerarCertificado } = useInterviewController();

  const formatDate = (date) => {
    return format(new Date(date), 'yyyy/MM/dd').replaceAll('/', '-');
  };
  const [data, setData] = React.useState(values);

  React.useEffect(() => {
    if (!moduleSelected?.id) return;
    if (moduleSelected?.id === 3) {
      setCargaHoraria(44);
    }
  }, [moduleSelected]);

  const sendDataToGenerateCertificate = React.useCallback(() => {
    setLoadingButton(true);
    const dataParsed = {
      beginDate: formatDate(new Date(initialDate), 'yyyy/MM/dd'),
      endDate: formatDate(new Date(finalDate), 'yyyy/MM/dd'),
      courseHours: cargaHoraria.toString(),
      generateCertificateClass: false,
      idsInterview: values.map((value) => value.id),
    };
    gerarCertificado(dataParsed)
      .then(() => {
        showNotification({
          message: 'Sucesso!',
          supportMessage:
            'Solicitação enviada. Aguarde a geração do certificado.',
          secondsToClose: 5,
          color: 'confirmation',
        });
      })
      .then(() => reloadData())
      .finally(() => {
        setLoadingButton(false);
        closeModal('');
      });
  }, [
    initialDate,
    finalDate,
    cargaHoraria,
    values,
    gerarCertificado,
    closeModal,
    showNotification,
    reloadData,
  ]);

  return (
    <Container>
      {confirmGenerate ? (
        <ConfirmGenerateCertificate
          finalDate={finalDate}
          initialDate={initialDate}
          cargaHoraria={cargaHoraria}
        />
      ) : (
        <GenerateCertificateData
          data={data}
          finalDate={finalDate}
          setData={setData}
          setFinalDate={setFinalDate}
          setInitialDate={setInitialDate}
          initialDate={initialDate}
          cargaHoraria={cargaHoraria}
          setCargaHoraria={setCargaHoraria}
        />
      )}

      {confirmGenerate ? (
        <FooterContainer>
          <BaSeButton
            value="Confirmar"
            isLoading={loadingButton}
            onClick={() => {
              // setConfirmGenerate((prev) => !prev);
              sendDataToGenerateCertificate();
            }}
            color={BaSeTheme.colors.defaultColors.black}
          />
          <BaSeButton
            value="Revisar"
            type="secondary"
            color={BaSeTheme.colors.defaultColors.black}
            onClick={() => setConfirmGenerate((prev) => !prev)}
          />
        </FooterContainer>
      ) : (
        <FooterContainer>
          <BaSeButton
            value="Gerar certificado"
            onClick={() => {
              if (
                initialDate === undefined ||
                finalDate === undefined ||
                cargaHoraria === 0 ||
                cargaHoraria === undefined ||
                cargaHoraria === ''
              ) {
                showNotification({
                  message: 'Erro!',
                  supportMessage:
                    'É necessário preencher todas as informações sobre o seminário!',
                  secondsToClose: 5,
                  color: 'destructive',
                });
                return;
              }
              setConfirmGenerate((prev) => !prev);
            }}
            color={BaSeTheme.colors.defaultColors.black}
          />
          <BaSeButton
            value="Cancelar"
            type="secondary"
            color={BaSeTheme.colors.defaultColors.black}
            onClick={() => closeModal()}
          />
        </FooterContainer>
      )}
    </Container>
  );
}

export default GenerateCertificate;
